import countries from "i18n-iso-countries";
import ptLocale from "i18n-iso-countries/langs/pt.json";
import enLocale from "i18n-iso-countries/langs/en.json";

countries.registerLocale(ptLocale);
countries.registerLocale(enLocale);

/**
 * [{ code: "PT", label: "Portugal" }, ...]
 * @param {string} lang - "pt" ou "en"
 * @returns {Array<{code: string, label: string}>}
 */
export const getCountryOptions = (lang = "pt") => {
  const names = countries.getNames(lang, { select: "official" });
  return Object.entries(names)
    .map(([code, label]) => ({ code, label }))
    .sort((a, b) => a.label.localeCompare(b.label, lang));
};

/**
 * @param {string} code
 * @param {string} lang
 * @returns {string}
 */
export const getCountryLabel = (code, lang = "pt") => {
  if (!code) return "N/A";
  return countries.getName(code, lang) || code;
};

export default function getAPIbaseURL() {
    return process.env.REACT_APP_API_BASE_URL || '/api';
}

// 


/** 
 * @param {Object} obj
 * @returns {string} 
 */
export const getFullName = (obj) => {
  if (!obj) return "Desconhecido";
  const fullName = `${obj.first_name || ""} ${obj.last_name || ""}`.trim();
  return fullName || obj.username || obj.user_name || "Desconhecido";
};

/**
 * 
 * @param {Array} users 
 * @returns {Array} 
 */
export const formatUsers = (users = []) =>
  users.map((user) => {
    const name = getFullName(user);

    return {
      id: user.id,
      name,
      label: name,
      avatar:
        user.profile_picture ||
        `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=F3F4F6&color=17296b`,

      email: user.email,
      status: user.public_status || "Active",
    };
  });
/**
 * 
 * @param {Array} apiHolidays 
 * @returns {Array} 
 */
export const formatHolidays = (apiHolidays = []) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const monthNames = ["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"];
  const weekdayNames = ["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"];

  return apiHolidays
    .map((h) => ({ ...h, dateObj: new Date(h.date) }))
    .filter((h) => h.dateObj >= today)
    .sort((a, b) => a.dateObj - b.dateObj)
    .map((h, index) => ({
      id: h.id || index,
      day: h.dateObj.getDate(),
      month: monthNames[h.dateObj.getMonth()],
      weekday: weekdayNames[h.dateObj.getDay()],
      holiday_name: h.label || h.name || "Feriado",
      type: h.type || "official",
    }));
};

// medical leave 
export const toFormData = (obj) => {
  const formData = new FormData();
  
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    
    if (value === null || value === undefined) return;

    if (typeof value === 'boolean') {
      formData.append(key, value.toString());
    } 
    else if (value instanceof Date) {
      formData.append(key, value.toISOString());
    }
    else {
      formData.append(key, value);
    }
  });
  
  return formData;
};

export const PT_SUBDIVISIONS = [
  { code: "PT-01", label: "Aveiro" },
  { code: "PT-02", label: "Beja" },
  { code: "PT-03", label: "Braga" },
  { code: "PT-04", label: "Bragança" },
  { code: "PT-05", label: "Castelo Branco" },
  { code: "PT-06", label: "Coimbra" },
  { code: "PT-07", label: "Évora" },
  { code: "PT-08", label: "Faro" },
  { code: "PT-09", label: "Guarda" },
  { code: "PT-10", label: "Leiria" },
  { code: "PT-11", label: "Lisboa" },
  { code: "PT-12", label: "Portalegre" },
  { code: "PT-13", label: "Porto" },
  { code: "PT-14", label: "Santarém" },
  { code: "PT-15", label: "Setúbal" },
  { code: "PT-16", label: "Viana do Castelo" },
  { code: "PT-17", label: "Vila Real" },
  { code: "PT-18", label: "Viseu" },
  { code: "PT-20", label: "Região Autónoma dos Açores" },
  { code: "PT-30", label: "Região Autónoma da Madeira" },
];

export const getSubdivisionLabel = (code) => {
  const match = PT_SUBDIVISIONS.find((s) => s.code === code);
  return match ? match.label : code || "N/A";
};